import React, { useState, useEffect, useRef } from "react";
import { callCrashGameGraphQLQuery } from "../../utils/axiosClient";
import useWeb3 from "../../hooks/useWeb3";
import Web3 from "web3";
import { Log } from "ethers";
const RoundData = ({ currentIndex, shouldRun, shouldCrashNow }) => {
  const web3 = useWeb3();
  const intervalRef = useRef(null);
  const [uniquePlayersCount, setUniquePlayersCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [winningsHistory, setWinningsHistory] = useState([]);
  const totalPayout = winningsHistory.reduce((acc, bet) => {
    const payoutInEther = parseFloat(
      web3.utils.fromWei(String(bet.amount), "mwei")
    );
    return acc + payoutInEther;
  }, 0);
  function shortenAddress(address, chars = 4) {
    if (!address) return "";
    return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
  }
  const fetchCrashGameWinningsBets = async (currentIndex) => {
    const query = `
       query getCurrentPlayers{
  crashBetPlaceds(where: {index: ${currentIndex}}) {
      index
        amount
        blockTimestamp
        transactionHash
         blockNumber
    blockTimestamp
    player
    id
  }
}
      `;

    try {
      const data = await callCrashGameGraphQLQuery(query);

      const allBets = data?.crashBetPlaceds || [];

      // ✅ Sort by blockTimestamp in descending order (latest on top)
      const sortedBets = allBets.sort(
        (a, b) => Number(b.blockTimestamp) - Number(a.blockTimestamp)
      );

      setWinningsHistory(sortedBets);

      // ✅ Extract unique players
      const uniquePlayers = Array.from(
        new Set(sortedBets.map((bet) => bet.player?.toLowerCase()))
      );

      setUniquePlayersCount(uniquePlayers.length);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (currentIndex || shouldCrashNow) {
      setTimeout(() => {
        fetchCrashGameWinningsBets(currentIndex - 1);
      }, 2000);
    }
  }, [currentIndex, shouldCrashNow]);

  useEffect(() => {
    if (shouldRun) {
      // Start interval
      intervalRef.current = setInterval(() => {
        fetchCrashGameWinningsBets(currentIndex);
      }, 4000); // every 1 second
    } else {
      // Clear interval when stopped
      clearInterval(intervalRef.current);
    }

    // Cleanup on unmount or when shouldRun changes
    return () => clearInterval(intervalRef.current);
  }, [shouldRun, currentIndex]);

  return (
    <div>
      <div className="rightbottom">
        <div className="bottomhead">
          <h6 className="headpara">{uniquePlayersCount} Players</h6>
          <h6 className="headpara">${totalPayout?.toFixed(2)}</h6>
        </div>
        <div className="bettingdetails">
          <div className="mainbet">
            <p className="firstpara">Player</p>
            {/* <p>Cashout</p> */}
            <p>Amount</p>
          </div>
          <div className="innerdetail">
            {winningsHistory &&
              winningsHistory?.length > 0 &&
              winningsHistory?.map((bet) => (
                <div className="innerbet" key={bet?.id}>
                  <p className="firsthead"> {shortenAddress(bet?.player)}</p>
                  {/* <p>
                    {parseFloat(
                      Web3.utils.fromWei(String(bet?.payout), "mwei")
                    ).toFixed(2)}
                  </p> */}
                  <p>
                    $
                    {(() => {
                      const betAmountInEther = parseFloat(
                        Web3?.utils?.fromWei(String(bet?.amount), "mwei")
                      );
                      return betAmountInEther?.toFixed(2);
                    })()}{" "}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoundData;
